import { ActionTypes } from './action'
import { EntityClass } from '../types'

export function selectEntityClass (entityClass: EntityClass) {
    return {
        type: ActionTypes.WORKSPACE_PRE_SELECT_ENTITY_CLASS,
        target: entityClass
    }
}
